import * as React from "react";
import { ClearSearch } from "source/app/presentation/MainPanel/Workflows/SearchNodes/Clear/ClearSearch";
import { defaultSearchNodesState } from "source/app/presentation/MainPanel/Workflows/SearchNodes/Helpers/defaultSearchNodesState";
import { ISearchNodeProps } from "source/app/presentation/MainPanel/Workflows/SearchNodes/Helpers/ISearchNodeProps";
import { ISearchNodesState } from "source/app/presentation/MainPanel/Workflows/SearchNodes/Helpers/ISearchNodesState";
import { minSearchLength } from "source/app/presentation/MainPanel/Workflows/SearchNodes/Helpers/minSearchLength";
import { SearchResults } from "source/app/presentation/MainPanel/Workflows/SearchNodes/Results/SearchResults";
import { SearchBox } from "source/app/presentation/MainPanel/Workflows/SearchNodes/SearchBox/SearchBox";
import { SearchWarning } from "source/app/presentation/MainPanel/Workflows/SearchNodes/Warning/SearchWarning";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import { LoadComponentStateAsync } from "../../../../infrastructure/Data/MotwIndexedDb";
import { RenderDiv } from "../../../Shared/Render";
import * as styles from "./SearchNodes.css";

export class SearchNodes extends React.Component<
    ISearchNodeProps,
    ISearchNodesState
> {
    constructor(props: ISearchNodeProps) {
        super(props);
        this.state = defaultSearchNodesState;
    }

    async componentDidMount() {
        await LoadComponentStateAsync(this);
        State.ShareClass(ESharedComponent.SearchNodes, this);
    }

    async componentDidUpdate(
        prevProps: ISearchNodeProps,
        prevState: ISearchNodesState
    ) {
        State.ShareClass(ESharedComponent.SearchNodes, this);
    }

    render() {
        const isUserSearching = this.state.searchText !== "";

        const hasEnoughCharacters =
            this.state.searchText.length >= minSearchLength;

        const doSearchResultsExist = this.state.filteredNodes.length > 0;

        return (
            <div id="scrollTarget_searchAddNodes">
                <SearchBox
                    SearchNodes={this}
                    ClearSearch={ClearSearch}
                    rootNode={this.props.rootNode}
                    canAddNode
                />
                <RenderDiv
                    id="searchResultsContainer"
                    when={true}
                    withClasses={styles.searchResults}
                >
                    <SearchWarning
                        when={isUserSearching && !hasEnoughCharacters}
                    >
                        Not enough characters.
                    </SearchWarning>
                    <SearchWarning when={false}>
                        At node limit. Delete a node to add a new one.
                    </SearchWarning>
                    <SearchWarning
                        when={
                            isUserSearching &&
                            hasEnoughCharacters &&
                            !doSearchResultsExist
                        }
                    >
                        No results found.
                    </SearchWarning>
                    <SearchResults
                        showFavorites={this.state.showFavorites}
                        filteredNodes={this.state.filteredNodes}
                        favoriteNodes={this.props.favoriteNodes}
                    />
                </RenderDiv>
            </div>
        );
    }
}
